export enum VerifyErrorType {
  Token = 'token',
  SiteId = 'site_id',
  CompanyId = 'company_id',
  SubsXVI = 'subs_xvi',
}
